export default __webpack_public_path__ + "static/media/ad-2.c1622cb7.png";